<script lang="ts">
  import Loading from '../etc/loader.svelte';
  import RepositoryFactory, { CONTRACT, SIM_EXCHANGE_DELIVERY, MNP } from '../repositories/RepositoryFactory';
  import { loginUser } from '../components/auth/LoginUser';
  import { push } from 'svelte-spa-router';
  import type { GetSimExchangeDeliveryHistoryResult } from '../repositories/simexchangedelivery';
  import modifySimChangeModal from '../etc/modal/ModifySimChangeModal.svelte';
  import { getContext } from 'svelte';
  import type { GetContractResult } from '../repositories/contract';
  import { isAvailableMnpReserveNumberRequest } from '../components/Util.svelte';
  const { open }: any = getContext('simple-modal');

  let deliveryStatusCode = '',
    mnpNumberIssueStatus = '';
  let simExchangeDeliveryHistoryList: GetSimExchangeDeliveryHistoryResult[], contract: GetContractResult;

  let promise = getApi();

  $: disabledRequest =
    ['ACCEPT', 'REQUEST'].includes(deliveryStatusCode) ||
    // 申出停止以外の理由での停止中はSIM再発行不可
    isNotAppliedSuspend() ||
    // MNP予約番号発行中はSIM再発行不可
    !isAvailableMnpReserveNumberRequest(mnpNumberIssueStatus);

  // SIM交換履歴取得
  async function getApi() {
    const simExchangeRepository = RepositoryFactory[SIM_EXCHANGE_DELIVERY];
    const contractRepository = RepositoryFactory[CONTRACT];
    const mnpRepository = RepositoryFactory[MNP];

    await Promise.all([
      simExchangeRepository.getSimExchangeDeliveryHistory(),
      contractRepository.getContract(),
      mnpRepository.getMnpReserveNumber()
    ])
      .then((res) => {
        if (!res) {
          throw new Error();
        }
        simExchangeDeliveryHistoryList = res[0];
        if (res[0].length > 0) {
          deliveryStatusCode = simExchangeDeliveryHistoryList[0].simDeliveryStatusCode;
        }
        contract = res[1];
        mnpNumberIssueStatus = res[2]?.issueStatusCode;
      })
      .catch((error) => {
        if (error.response.status === 403) {
          alert('セッションが切れました。再度ログインしてください。');
          loginUser.logout();
          location.reload();
        } else {
          alert('エラーが発生しました。');
        }
      });
    return simExchangeDeliveryHistoryList;
  }

  const showModifySimChangeModal = () => {
    open(modifySimChangeModal);
  };

  const isNotAppliedSuspend = () => {
    return contract?.contractStatusCode === 'SUSPEND' && contract?.suspendReasonCode !== 'APPLIED';
  };
</script>

<!-- 本体 -->
<div class="mb-5 screen-title">
  <span class="text-gray-700 text-2xl font-bold">SIM交換履歴</span>
</div>

<div class="shadow rounded-lg bg-gray-50 border-1 p-8 mb-10 border-t-4 border-green-400">
  <div class="flex flex-col">
    <div class="flex-auto flex flex-col mb-4">
      <div class="flex-1">
        <div class="inline-grid md:grid-cols-3 justify-items-center items-center min-w-full">
          <div class="grid-1 col-span-2 justify-self-start w-full">SIM交換履歴は最新5件までの表示です</div>
          <div class="grid-1 flex flex-row justify-items-center items-center mt-2">
            <button class="button-primary mb-5" on:click={showModifySimChangeModal} disabled={disabledRequest}>
              SIM交換
            </button>
            <button class="button-primary ml-5 mb-5" on:click={() => push(`/contract/change/`)}> 戻る </button>
          </div>
        </div>
      </div>
    </div>

    <div class="flex-auto">
      <div class="overflow-x-auto">
        <div class="align-middle inline-block min-w-full">
          <div class="overflow-auto">
            <table class="min-w-full border-collapse border border-gray-800">
              <thead class="bg-gray-100">
                <tr>
                  <th class="w-1/7">依頼状態</th>
                  <th class="w-1/7">依頼日</th>
                  <th class="w-1/7">出荷日</th>
                  <th class="w-1/7">着荷日</th>
                  <th class="w-1/7">伝票番号</th>
                  <th class="w-1/7">配送先住所</th>
                  <th class="w-1/7">配送先顧客名</th>
                </tr>
              </thead>
              {#await promise}
                <Loading />
              {:then simExchangeDeliveryHistoryList}
                <tbody>
                  {#each simExchangeDeliveryHistoryList as sim}
                    <tr class="group">
                      <td>{sim.simDeliveryStatus}</td>
                      <td>{sim.deliveryRequestDate}</td>
                      <td>{sim.deliveryShipDate ?? '-'}</td>
                      <td>{sim.deliveryArrivalDate ?? '-'}</td>
                      <td>
                        {#if sim.deliveryVoucherNumber}
                          <a
                            class="underline"
                            href="https://trackings.post.japanpost.jp/services/srv/search/direct?locale=ja&reqCodeNo1={sim.deliveryVoucherNumber}"
                            rel="noopener noreferrer"
                            target="_blank"
                          >
                            {sim.deliveryVoucherNumber}</a
                          >
                        {:else}
                          -
                        {/if}
                      </td>
                      <td
                        >{sim.deliveryPrefecture +
                          sim.deliveryCity +
                          sim.deliveryStreet +
                          (sim.deliveryBuilding ?? '')}</td
                      >
                      <td>{sim.deliveryCustomerSei + sim.deliveryCustomerMei}</td>
                    </tr>
                  {/each}
                </tbody>
              {/await}
            </table>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<style lang="postcss">
  .button-primary {
    @apply bg-green-400 rounded-lg hover:bg-green-500 focus:outline-none text-sm font-semibold text-white px-10 py-2;
  }
  .button-primary:disabled {
    @apply opacity-30 cursor-default;
  }

  thead tr th {
    @apply border border-gray-800 px-4 py-3 text-center text-sm text-gray-700 whitespace-nowrap leading-4;
  }
  tbody tr td {
    @apply border border-gray-800 px-4 py-3 text-center text-sm text-gray-700 whitespace-nowrap leading-4;
  }
  .screen-title {
    text-align: left;
  }
  @media screen and (max-width: 640px) {
    .screen-title {
      text-align: center;
    }
  }
</style>
